__turbopack_context__.v({
  "blink": "AllModules-module-scss-module__vFcUkG__blink",
  "sectionColumns": "AllModules-module-scss-module__vFcUkG__sectionColumns",
});
